import React from 'react';
import { GreeningBrandLabel } from './GreeningBrandLabel';

/** Frase de proteção — GreeningAI em verde e azul. */
export function GreeningDisclaimer() {
  return (
    <>
      Análise de apoio gerada pela <GreeningBrandLabel />
      ; não substitui uma avaliação técnica ou jurídica.
    </>
  );
}

export default GreeningDisclaimer;
